export class ColumnSelector {
    constructor(public readonly id: string, public readonly name: string, public selected: boolean) {

    }
}



// WEBPACK FOOTER //
// ./src/app/stocks/models/column-selector.ts